import clsx from "clsx";
import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

import {
  Shortcut,
  ShortcutAction,
  Shortcuts,
  ShortcutsHeader,
  ShortcutsList,
  ShortcutsTally,
  ShortcutsTitle,
} from "@components/shortcuts";

import { OrgsRoute, RootPath } from "@lib/routes.config";
import { createDashboardLink } from "@lib/utils/navigation.utils";
import { useCurrentUser } from "@queries/account";
import { useOrganizations } from "@queries/organization";
import {
  useTotalClassrooms,
  useTotalInstructors,
  useTotalTrainees,
} from "@queries/organization-selectors";
import { getLearnerTerm } from "@transfr-inc/dashboard-components/constants";

export function OrgsShortcuts({ className }) {
  const { url } = useRouteMatch(`${RootPath}`);
  const history = useHistory();
  const orgsPath = `${url}${OrgsRoute.path}`;
  const currentUser = useCurrentUser();
  const { organizationCode, organizationName } = currentUser || {};

  const { data: organizations = [] } = useOrganizations(organizationCode, {
    enabled: !!organizationCode,
  });
  const totalClassrooms = useTotalClassrooms(organizationCode);
  const totalInstructors = useTotalInstructors(organizationCode);
  const totalTrainees = useTotalTrainees(organizationCode);

  const orgStats = [
    {
      description: "Orgs",
      value: organizations.length > 0 ? organizations.length : "-",
    },
    {
      description: "Classrooms",
      value: totalClassrooms || "-",
    },
    {
      description: "Instructors",
      value: totalInstructors || "-",
    },
    {
      description: `${getLearnerTerm({ plural: true })}`,
      value: totalTrainees || "-",
    },
  ];

  const onManageOrgsClick = () => {
    history.push(orgsPath);
  };

  return (
    <Shortcuts className={clsx("orgs-shortcuts-container", className)}>
      <div className="orgs-shortcuts-header">
        <ShortcutsHeader icon="fa-light fa-sitemap" />
        <ShortcutsTitle text={organizationName}></ShortcutsTitle>
      </div>
      <ShortcutsTally columns={orgStats}></ShortcutsTally>
      <ShortcutsList>
        {organizations.map((d, i) => (
          <Shortcut
            key={i}
            to={createDashboardLink({
              orgCode: d.code,
              search: {
                from: "Dashboard",
              },
            })}
            products={d.products}
            title={d.name}
            subtitle={`${d.totalTrainees} Users`}
          ></Shortcut>
        ))}
      </ShortcutsList>
      <div className="manage-action">
        <ShortcutAction onClick={onManageOrgsClick}>
          Manage Organizations
        </ShortcutAction>
      </div>
    </Shortcuts>
  );
}
